import { Divider } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Company } from '/src/lib/models';

export type FinancialOverviewProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Company to display financial overview for
   */
  company?: Company;
};

export const FinancialOverview: React.FC<FinancialOverviewProps> = ({ company, open, toggleOpen }) => (
  <SidebarItem title="Financial Overview" open={open} toggleOpen={toggleOpen} resolved={!!company}>
    <InfoItem title="Original Assets" value={company?.originalAssets} currency />
    <InfoItem title="Deposited Payments" value={company?.currentPayments} currency />
    <InfoItem title="Adjustments" value={company?.currentAdjustments} currency />
    <Divider />
    <InfoItem title="Current Value" bold value={company?.currentValue} currency />
    <Divider />
    <InfoItem title="Total Credit" value={company?.currentCredit} currency />
    <InfoItem title="Principal Balances" value={company?.currentPrincipalBalances} currency />
    <Divider />
    <InfoItem title="Current Available Credit" bold value={company?.currentAvailableCredit} currency />
  </SidebarItem>
);
